import { render } from "./ExamInsurance.vue?vue&type=template&id=5367efea"
import script from "./ExamInsurance.vue?vue&type=script&lang=js"
export * from "./ExamInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__